import type { CSSProperties } from "react";
import { cn } from "src/utilities/shadcnUtils";

export interface ThreeDotsWaveProps {
  className?: string;
  dotClassName?: string;
  dotStyle?: CSSProperties;
  size?: number;
}

const DOT_DELAYS = ["0s", "0.2s", "0.4s"];

const ThreeDotsWave = ({ className, dotClassName, dotStyle, size = 5 }: ThreeDotsWaveProps) => {
  const radius = { width: size, height: size, borderRadius: size, ...dotStyle };
  return (
    <div className={cn("flex justify-around", className)} style={{ width: size * 5, height: size * 2 }}>
      {DOT_DELAYS.map((animationDelay) => (
        <span
          key={animationDelay}
          className={cn("block bg-muted-foreground animate-dot-wave", dotClassName)}
          style={{ ...radius, animationDelay }}
        />
      ))}
    </div>
  );
};

export default ThreeDotsWave;
